module.exports = __webpack_public_path__ + "img/2025-03-14-02-02.770c599b.png";